import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNewspaper2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"newspaper-2, guide, info, faq, book"} maskId="square-filled-radius-0-stroke-1-IconNewspaper2"><path d="M11.5 7.5C11.5 5.567 9.933 4 8 4H1V20H9C9.94163 20 10.556 20.2002 10.9294 20.5123C11.2858 20.8103 11.5 21.2758 11.5 22V7.5Z" fill="currentColor"/><path d="M12.5 22C12.5 21.2758 12.7142 20.8103 13.0706 20.5123C13.444 20.2002 14.0584 20 15 20H23V4H16C14.067 4 12.5 5.567 12.5 7.5V22Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNewspaper2;
